import _ from 'lodash'
import { TextLink } from '@components/atoms'
import { Typography } from '@mui/material'
import { EventEntity } from '@services/nomos_api/entities/event'
import { useMemo } from 'react'

type Props = {
  event: EventEntity
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
  index: number
}

export function HighlightedPropositionScheduled({
  event,
  data,
  index,
}: Props): JSX.Element | null {
  if (!event) return null

  const propositionSummary = _.get(data, `${index}.summary`, '').toLowerCase()

  const highlightWords =
    event.highlights?.reduce((words, highlight) => {
      if (highlight.path === 'schedule.summary') {
        words.push(
          ...highlight.texts
            .filter((text) => text.type === 'hit')
            .map((text) => text.value.toLowerCase())
        )
      }
      return words
    }, [] as string[]) ?? []

  const hasHighlightInProposition = highlightWords.some((word) =>
    propositionSummary.includes(word)
  )

  const propositionId = _.get(data, `${index}.propositionId`)

  const color = useMemo(() => {
    if (hasHighlightInProposition) {
      return '#FFB829'
    }
    if (propositionId) {
      return '#2970FF'
    }
    return '#606162'
  }, [hasHighlightInProposition, propositionId])

  const title = _.get(data, `${index}.title`)

  return propositionId ? (
    <TextLink
      target="_blank"
      text={title}
      underline="none"
      color={color}
      href={`/propositions/${propositionId}`}
    />
  ) : (
    <Typography variant="$font-text-link" color={color}>
      {title}
    </Typography>
  )
}
